export default __webpack_public_path__ + "static/10-bce425d5edec6105dbc8faf371db880f.png";